export default __webpack_public_path__ + "static/media/SA_BACK2.6c207289.png";